import React from 'react'
import './process.css' 

function Process() {
    return (
        <div className="process">
            <div className="process-container">

                <h2>Our Work Process</h2>
                <div className="process-wrap">
                    <div>
                        <img src='imgs/cart.svg' alt="" />
                        <div>
                            <h3>1 Title here</h3>
                            <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Animi, ad quisquam? Corrupti magnam tempore maxime debitis reprehenderit delectus. Adipisci ipsum, natus praesentium sint a unde obcaecati deleniti? Necessitatibus, deserunt rem.</p>
                        </div>
                    </div>
                    <div>
                        <img src='imgs/del.svg' alt="" />
                        <div>
                            <h3>2 Title here</h3>
                            <p> dipisicing elit. Animi, ad quisquam? Corrupti magnam tempore maxime debitis reprehenderit delectus. Adipisci ipsum, natus praesentium sint a unde obcaecati deleniti? Necessitatibus, deserunt rem.</p>
                        </div>
                    </div>
                    <div>
                        <img src='imgs/arrows.svg' alt="" />
                        <div>
                            <h3>Something here</h3>
                            <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Animi, ad quisquam? Corrupti magnam tempore maxime debitis reprehenderit delectus..</p>
                        </div>
                    </div>
                    <div>
                        <img src='imgs/setting.svg' alt="" />
                        <div>
                            <h3>Title here</h3>
                            <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Animi, ad quisquam? Corrupti magnam tempore maxime debitis reprehenderit delectus. Adipisci ipsum, natus praesentium sint a unde obcaecati deleniti? Necessitatibus, deserunt rem.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Process
